// extracted by mini-css-extract-plugin
export default {"subtitleHighlight":"Learners_subtitleHighlight__B1y64","article":"Learners_article__glyoX","contactInfo":"Learners_contactInfo__d4LXC","articles":"Learners_articles__gpScL"};